import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../helpers/axios";
import { ToggleNavContext } from "../../helpers/context";
import "./navigation.css";

export default function Navigation() {
  const navigate = useNavigate();
  const { isToggled, setToggle } = useContext(ToggleNavContext);

  const logOut = async () => {
    const res = await axios.get("/user/logout");
    localStorage.clear();
    if (res.status === 200) {
      navigate("/");
    }
  };

  return (
    <div className="nav-body">
      <nav className={isToggled ? "close" : null}>
        <div className="logo-name">
          <div className="logo-image">
            <img src="/img/akls_logo.png" alt="logo" />
          </div>

          <span className="logo_name">AKLS Delights</span>
        </div>

        <div className="menu-items">
          <ul className="nav-links">
            <li>
              <Link to="/dashboard">
                <i className="uil uil-estate"></i>
                <span className="link-name">Dashboard</span>
              </Link>
            </li>
          </ul>

          <ul className="nav-links">
            <li>
              <Link to="/product">
                <i className="uil uil-shopping-cart"></i>
                <span className="link-name">Product</span>
              </Link>
            </li>
            <li>
              <Link to="/purchase">
                <i className="uil uil-wallet"></i>
                <span className="link-name">Purchase</span>
              </Link>
            </li>
            <li>
              <Link to="/category">
                <i className="uil uil-tag-alt"></i>
                <span className="link-name">Category</span>
              </Link>
            </li>
          </ul>

          <ul className="nav-links">
            <li>
              <Link to="/invoice">
                <i className="uil uil-bill"></i>
                <span className="link-name">Invoice</span>
              </Link>
            </li>
            <li>
              <Link to="/bottle-return">
                <i className="uil uil-redo"></i>
                <span className="link-name">Bottle Return</span>
              </Link>
            </li>
            <li>
              <Link to="/damage">
                <i className="uil uil-image-broken"></i>
                <span className="link-name">Damage/Returns</span>
              </Link>
            </li>
          </ul>

          <ul className="nav-links">
            <li>
              <Link to="/customer">
                <i className="uil uil-user-arrows"></i>
                <span className="link-name">Customer</span>
              </Link>
            </li>
            <li>
              <Link to="/order">
                <i className="uil uil-shopping-cart"></i>
                <span className="link-name">Order</span>
              </Link>
            </li>
            <li>
              <Link to="/customer-account">
                <i className="uil uil-book-reader"></i>
                <span className="link-name">Customer Acc</span>
              </Link>
            </li>
            <li>
              <Link to="/customer-feedback">
                <i className="uil uil-chat-bubble-user"></i>
                <span className="link-name">Customer Feedback</span>
              </Link>
            </li>
          </ul>

          <ul className="nav-links">
            <li>
              <Link to="/supplier">
                <i className="uil uil-user-md"></i>
                <span className="link-name">Supplier</span>
              </Link>
            </li>
            <li>
              <Link to="/supplier-feedback">
                <i className="uil uil-chat-bubble-user"></i>
                <span className="link-name">Supplier Feedback</span>
              </Link>
            </li>
          </ul>

          <ul className="nav-links">
            <li>
              <Link to="/staff">
                <i className="uil uil-constructor"></i>
                <span className="link-name">Staff</span>
              </Link>
            </li>
            <li>
              <Link to="/workflow">
                <i className="uil uil-channel-add"></i>
                <span className="link-name">Work Flow</span>
              </Link>
            </li>
            <li>
              <Link to="/promotion">
                <i className="uil uil-money-insert"></i>
                <span className="link-name">Promotions</span>
              </Link>
            </li>
            <li>
              <Link to="/role">
                <i className="uil uil-user-square"></i>
                <span className="link-name">Role</span>
              </Link>
            </li>
            <li>
              <Link to="/user">
                <i className="uil uil-user"></i>
                <span className="link-name">Users</span>
              </Link>
            </li>
          </ul>

          <ul className="logout-mod">
            <li>
              <div onClick={logOut}>
                <a href="#">
                  <i className="uil uil-signout"></i>
                  <span className="link-name">Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
